var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shopping-cart-empty-box"},_vm._l((_vm.list),function(row,index){return _c('div',{key:index,staticClass:"shopping-cart-empty-box__item",on:{"click":function($event){return _vm.goLink(row)}}},[_c('h3',[_vm._v(_vm._s(row.title))]),_c('img',{attrs:{"src":row.img,"alt":""}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }